import React from "react";
import styles from "assets/jss/material-dashboard-react/components/chucnangStyle.js";
const useStyles = makeStyles(styles);
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
const Thongkephuongtien = React.memo(function Thongkephuongtien(props) {
  const classes = useStyles();
  const { phuongtien } = props;
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tabledb_th}>Phương tiện cơ giới đường bộ</th>
          <th className={classes.tabledb_th}>Số lượng xe đăng ký kinh doanh</th>
          <th className={classes.tabledb_th}>
            Số lượng xe không đăng ký kinh doanh
          </th>
          <th className={classes.tabledb_th}>Tổng số lượng</th>
          <th className={classes.tabledb_th}>Ghi chú</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        <tr>
          <td className={classes.tabledb_td}>1. Xe con</td>
          <td className={classes.tabledb_td}>{phuongtien[0].xecon_kd}</td>
          <td className={classes.tabledb_td}>{phuongtien[0].xecon_kkd}</td>
          <td className={classes.tabledb_td}>{phuongtien[0].xecon}</td>
          <td className={classes.tabledb_td}></td>
        </tr>
        <tr>
          <td className={classes.tabledb_td}>
            2. Xe khách (từ 10 chỗ trở lên)
          </td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xekhach_10_25_kd +
              phuongtien[0].xekhach_26_46_kd +
              phuongtien[0].xekhach_tren46_kd}
          </td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xekhach_10_25_kkd +
              phuongtien[0].xekhach_26_46_kkd +
              phuongtien[0].xekhach_tren46_kkd}
          </td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xekhach_10_25 +
              phuongtien[0].xekhach_26_46 +
              phuongtien[0].xekhach_tren46}
          </td>
          <td className={classes.tabledb_td}></td>
        </tr>
        <tr>
          <td className={classes.tabledb_td}>- Từ 10 đến 25 chỗ</td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xekhach_10_25_kd}
          </td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xekhach_10_25_kkd}
          </td>
          <td className={classes.tabledb_td}>{phuongtien[0].xekhach_10_25}</td>
          <td className={classes.tabledb_td}></td>
        </tr>
        <tr>
          <td className={classes.tabledb_td}>- Từ 26 đến 46 chỗ</td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xekhach_26_46_kd}
          </td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xekhach_26_46_kkd}
          </td>
          <td className={classes.tabledb_td}>{phuongtien[0].xekhach_26_46}</td>
          <td className={classes.tabledb_td}></td>
        </tr>
        <tr>
          <td className={classes.tabledb_td}>- Trên 46 chỗ</td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xekhach_tren46_kd}
          </td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xekhach_tren46_kkd}
          </td>
          <td className={classes.tabledb_td}>{phuongtien[0].xekhach_tren46}</td>
          <td className={classes.tabledb_td}></td>
        </tr>
        <tr>
          <td className={classes.tabledb_td}>3. Xe tải</td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xetai_den2_kd +
              phuongtien[0].xetai_2_7_kd +
              phuongtien[0].xetai_7_20_kd +
              phuongtien[0].xetai_tren20_kd}
          </td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xetai_den2_kkd +
              phuongtien[0].xetai_2_7_kkd +
              phuongtien[0].xetai_7_20_kkd +
              phuongtien[0].xetai_tren20_kkd}
          </td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xetai_den2 +
              phuongtien[0].xetai_2_7 +
              phuongtien[0].xetai_7_20 +
              phuongtien[0].xetai_tren20}
          </td>
          <td className={classes.tabledb_td}></td>
        </tr>
        <tr>
          <td className={classes.tabledb_td}>- Tải trọng đến 2 tấn</td>
          <td className={classes.tabledb_td}>{phuongtien[0].xetai_den2_kd}</td>
          <td className={classes.tabledb_td}>{phuongtien[0].xetai_den2_kkd}</td>
          <td className={classes.tabledb_td}>{phuongtien[0].xetai_den2}</td>
          <td className={classes.tabledb_td}></td>
        </tr>
        <tr>
          <td className={classes.tabledb_td}>
            - Tải trọng từ trên 2 tấn đến 7 tấn
          </td>
          <td className={classes.tabledb_td}>{phuongtien[0].xetai_2_7_kd}</td>
          <td className={classes.tabledb_td}>{phuongtien[0].xetai_2_7_kkd}</td>
          <td className={classes.tabledb_td}>{phuongtien[0].xetai_2_7}</td>
          <td className={classes.tabledb_td}></td>
        </tr>
        <tr>
          <td className={classes.tabledb_td}>
            - Tải trọng từ trên 7 tấn đến 20 tấn
          </td>
          <td className={classes.tabledb_td}>{phuongtien[0].xetai_7_20_kd}</td>
          <td className={classes.tabledb_td}>{phuongtien[0].xetai_7_20_kkd}</td>
          <td className={classes.tabledb_td}>{phuongtien[0].xetai_7_20}</td>
          <td className={classes.tabledb_td}></td>
        </tr>
        <tr>
          <td className={classes.tabledb_td}>
            - Tải trọng trên 20 tấn, xe đầu kéo
          </td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xetai_tren20_kd}
          </td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].xetai_tren20_kkd}
          </td>
          <td className={classes.tabledb_td}>{phuongtien[0].xetai_tren20}</td>
          <td className={classes.tabledb_td}></td>
        </tr>
        <tr>
          <td className={classes.tabledb_td}>4. Xe chuyên dụng và xe khác</td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].somiromooc_kd + phuongtien[0].xechuyendung_kd}
          </td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].somiromooc_kkd + phuongtien[0].xechuyendung_kkd}
          </td>
          <td className={classes.tabledb_td}>
            {phuongtien[0].somiromooc + phuongtien[0].xechuyendung}
          </td>
          <td className={classes.tabledb_td}></td>
        </tr>
        <tr>
          <td className={classes.tabledb_td}>- Sơ mi rơ moóc</td>
          <td className={classes.tabledb_td}>{phuongtien[0].somiromooc_kd}</td>
          <td className={classes.tabledb_td}>{phuongtien[0].somiromooc_kkd}</td>
          <td className={classes.tabledb_td}>{phuongtien[0].somiromooc}</td>
          <td className={classes.tabledb_td}></td>
        </tr>
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = phuongtien.length > 0 ? renderTableBody() : null;
  return (
    <div className={classes.table} style={{ height: "350px" }}>
      <table className={classes.tabledb}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
});

Thongkephuongtien.propTypes = {
  phuongtien: PropTypes.array,
};
export default Thongkephuongtien;
